"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotion = require("emotion");

var _spacing = _interopRequireDefault(require("@amzn/meridian-tokens/base/spacing"));

var _divider = _interopRequireDefault(require("@amzn/meridian-tokens/component/divider"));

var _theme = require("../theme");

var _token = require("./../_utils/token");

var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var size = _ref.size,
      spacingBefore = _ref.spacingBefore,
      spacingAfter = _ref.spacingAfter;
  return (0, _emotion.css)({
    width: "100%",
    height: t("size", size),
    // min-height protects against parent styling that might
    // squash the "normal" height with margins and flex (like Column)
    minHeight: t("size", size),
    backgroundColor: t("color"),
    marginTop: (0, _token.getToken)(_spacing["default"], "spacing", spacingBefore),
    marginBottom: (0, _token.getToken)(_spacing["default"], "spacing", spacingAfter),
    border: "none"
  });
}, ["size", "spacingBefore", "spacingAfter"]);

function Divider(props) {
  var t = (0, _theme.useTheme)(_divider["default"], "divider");
  return /*#__PURE__*/_react["default"].createElement("hr", {
    className: styles(t, props)
  });
}

Divider.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Sets the size of the component using a preset.
   */
  size: _propTypes["default"].oneOf(["small", "medium", "large", "xlarge"]),

  /**
   * Applies a [collapsible margin](https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Box_Model/Mastering_margin_collapsing)
   * after the divider.
   */
  spacingAfter: _propTypes["default"].oneOf(["none", "xxsmall", "xsmall", "small", "medium", "large", "xlarge"]),

  /**
   * Applies a [collapsible margin](https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Box_Model/Mastering_margin_collapsing)
   * before the divider.
   */
  spacingBefore: _propTypes["default"].oneOf(["none", "xxsmall", "xsmall", "small", "medium", "large", "xlarge"])
} : {};
Divider.defaultProps = {
  size: "medium",
  spacingBefore: "none",
  spacingAfter: "none"
};
var _default = Divider;
exports["default"] = _default;